The opaque cursor to the webhook attempt.

This can be used as a subsequent pagination argument.
